import React from "react";
import ShiningStar from "./shiningstar.svg";

function ShiningStarIcon() {
  return <img src={ShiningStar} alt="shining star icon" />;
}

export default ShiningStarIcon;
